export function withDomain(domain: string, url: string): string {
  return `${domain}/${url
    .replace(new RegExp(domain), '')
    .replace(new RegExp('^/'), '')}`
}
